import { Injectable } from '@angular/core';
import { GetQuoteDetailsService } from '@core/services/get-quote-details.service';
import { SharedDataService } from '@core/services/shared-data.service';

@Injectable()
export class BackButtonService {
  public constructor(public GetQuoteDetailsService: GetQuoteDetailsService, public SharedDataService: SharedDataService) {}

  public getFooterBackButton = () => {
    const footerBackButton = document.getElementById('previousButton');
    return footerBackButton;
  }

  public backButtonEventHandler = () => {
    // Find the back button and click it
    const footerBackButton = this.getFooterBackButton();
    if (footerBackButton) {
      console.log('Found the footer back button.');
      // Found back button
      footerBackButton.click();
    } else if (
      this.SharedDataService.data.steps &&
      this.SharedDataService.data.steps[this.SharedDataService.data.currentStep] &&
      this.SharedDataService.data.steps[this.SharedDataService.data.currentStep]['name'] == 'paymentFrequency'
    ) {
      // This condition allows the payment frequency service to finish and then click the back button.
      setTimeout(() => {
        this.backButtonEventHandler();
      }, 250);
    } else {
      console.log('Did not find the footer back button.');
      // No back button found
      /** Fire event to tell parent application to go to the previous page */
      this.GetQuoteDetailsService.dispatchEvents(window.top.document, 'goBack', 0);
    }
  }
}
